import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  contractBuilderUpperHeader: {
    width: '100%',
    minHeight: '50px',
    // backgroundColor: 'red',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  btnCenter: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '125px',
    fontSize: '15px',
  },
  contractBuilderLower: {
    width: '100%',
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
    overflowY: 'auto',
    overflowX: 'hidden',
    // backgroundColor: 'blue',
  },
  contractBuilderFooter: {
    width: '100%',
    // backgroundColor: 'red',
    position: 'absolute',
    bottom: 0,
    left: 0,
    borderTop: '1px solid rgba(0, 0, 0, 0.3)',
  },
  panelD: {
    padding: 0,
    margin: 0,
    position: 'relative',

    '& .ant-collapse-content-box': {
      paddingBottom: '50px',
    },
  },
});
